import { DataValidationError } from "constants/DataValidationError";
import { IsNotEmpty } from "class-validator";

export default class DeleteNotificationReq {
  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  readonly notificationId: number;

  constructor(arg: any) {
    arg = arg || {};
    this.notificationId = arg.notificationId;
  }
}
